import { ReactNode } from 'react';
import useSubscriptions from 'services/general/subscriptionsList';
import { urls } from '@repo/app-constants';
import { LinkButton } from 'components';

export const OrderKitButton = ({
  classNames,
  children,
}: {
  classNames?: string;
  children?: ReactNode;
}) => {
  const { isAnyTinyPlus, isTinyPlus } = useSubscriptions();
  return !isAnyTinyPlus ? (
    <div
      className={`flex flex-column justify-center align-items-center p-2 ${classNames} dont-print`}
    >
      <LinkButton
        href={`${urls.CHECKOUT_WITH_KIT_NON_TINY_PLUS}&utm_source=tinyhealth&utm_medium=webapp&utm_campaign=ap-cta`}
        className='m-0 button'
        external={true}
      >
        {children ? children : `Order Kit`}
      </LinkButton>
    </div>
  ) : (
    <div
      className={`flex flex-column justify-center align-items-center p-2 ${classNames} dont-print`}
    >
      <LinkButton
        href={`${
          isTinyPlus
            ? urls.CHECKOUT_WITH_KIT_TINY_PLUS
            : urls.CHECKOUT_WITH_KIT_TINY_PLUS_PROGRAM_OR_PROACTIVE
        }&utm_source=tinyhealth&utm_medium=webapp&utm_campaign=ap-cta`}
        className='m-0 button'
        external={true}
      >
        {children ? children : `Order Kit`}
      </LinkButton>
    </div>
  );
};
